let locale;
export function $(string) {
  return locale[string] || string;
}
export function loadLang() {
  //if (
  //    navigator.language.indexOf("uk") !== 0 &&
  //    navigator.language.indexOf("ru") !== 0 &&
  //    params.forceUk !== "true"
  //) {
  //    locale = require("../l10n/en.js").default;
  //} else {
  locale = require("./uk.js").default; //}

  Object.defineProperty($, "isLoaded", {
    value: true,
    writable: false,
    configurable: false
  });
  document.documentElement.lang = locale.lang;
}

function pluralUk(num, forms) {
  let n = Math.abs(num);
  n %= 100;

  if (n >= 5 && n <= 20) {
    return forms[2];
  }

  n %= 10;

  if (n === 1) {
    return forms[0];
  }

  if (n >= 2 && n <= 4) {
    return forms[1];
  }

  return forms[2];
}

function pluralEn(num, forms) {
  if (num === 1) {
    return forms[0];
  } else {
    return forms[1];
  }
}

export function plural(num, forms) {
  if (locale.lang === "uk") {
    return pluralUk(num, forms);
  } else {
    return pluralEn(num, forms);
  }
}